/**
 * /////////////////////////////////////////////////////////////////////////////
 *
 * https://keeptrack.space
 *
 * @Copyright (C) 2025 Kruczek Labs LLC
 *
 * KeepTrack is free software: you can redistribute it and/or modify it under the
 * terms of the GNU Affero General Public License as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * KeepTrack is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along with
 * KeepTrack. If not, see <http://www.gnu.org/licenses/>.
 *
 * /////////////////////////////////////////////////////////////////////////////
 */
import { SolarBody } from '@app/engine/core/interfaces';
import { SpaceObjectType } from '@ootk/src/main';
import { settingsManager } from '../../../../settings/settings';
import { CelestialBody, PlanetColors } from './celestial-body';
export var NeptuneTextureQuality;
(function (NeptuneTextureQuality) {
    NeptuneTextureQuality["POTATO"] = "512";
    NeptuneTextureQuality["HIGH"] = "4k";
    NeptuneTextureQuality["ULTRA"] = "2k";
})(NeptuneTextureQuality || (NeptuneTextureQuality = {}));
export class Neptune extends CelestialBody {
    RADIUS = 24622;
    NUM_HEIGHT_SEGS = 64;
    NUM_WIDTH_SEGS = 64;
    orbitalPeriod = 164.8 * 365.25 * 24 * 3600;
    meanDistanceToSun = 4498396441;
    type = SpaceObjectType.ICE_GIANT;
    eci;
    color = PlanetColors.NEPTUNE;
    textureQuality = NeptuneTextureQuality.POTATO;
    getTexturePath() {
        return `${settingsManager.installDirectory}textures/neptune${this.textureQuality}.jpg`;
    }
    getName() {
        return SolarBody.Neptune;
    }
    useHighestQualityTexture() {
        this.textureQuality = NeptuneTextureQuality.ULTRA;
        this.loadTexture();
    }
    draw(sunPosition, tgtBuffer = null) {
        if (!this.isLoaded_ || settingsManager.isDisablePlanets) {
            return;
        }
        super.draw(sunPosition, tgtBuffer);
    }
}
